import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 overflow-y-auto z-40"
}
const _hoisted_2 = { class: "flex items-end justify-center sm:min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = { class: "fixed inset-0 transition-opacity" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sm:inline-block sm:align-middle sm:h-screen" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("​ ")
const _hoisted_6 = {
  class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:p-6",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "modal-headline"
}
const _hoisted_7 = { class: "fixed top-2 right-2" }
const _hoisted_8 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_paper_modal_content = _resolveComponent("paper-modal-content")!
  const _component_author_modal_content = _resolveComponent("author-modal-content")!

  return (_ctx.validState)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-300",
            "enter-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "transition-opacity ease-in duration-200",
            "leave-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "absolute inset-0 bg-gray-500/75",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearModal()))
                })
              ], 512), [
                [_vShow, _ctx.validState]
              ])
            ]),
            _: 1
          }),
          _hoisted_4,
          _hoisted_5,
          _createVNode(_Transition, {
            "enter-active-class": "ease-out duration-300",
            "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
            "leave-active-class": "ease-in duration-200",
            "leave-class": "opacity-100 translate-y-0 sm:scale-100",
            "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "font-extrabold text-sm rounded-full h-5 w-5 bg-violet-500 text-white justify-center",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearModal()))
                  }, " X ")
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.isPaper)
                    ? (_openBlock(), _createBlock(_component_paper_modal_content, {
                        key: 0,
                        options: (_ctx.options as PaperModalOptions),
                        onClearModal: _ctx.clearModal,
                        onBack: _ctx.back
                      }, null, 8, ["options", "onClearModal", "onBack"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthor)
                    ? (_openBlock(), _createBlock(_component_author_modal_content, {
                        key: 1,
                        options: (_ctx.options as AuthorModalOptions),
                        onClearModal: _ctx.clearModal,
                        onBack: _ctx.back
                      }, null, 8, ["options", "onClearModal", "onBack"]))
                    : _createCommentVNode("", true)
                ])
              ], 512), [
                [_vShow, _ctx.validState]
              ])
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}